import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { BlankSurveyDialogComponent } from "../newSurveyDialog/blank-survey-dialog.component";
import { RestApiService } from '../shared/restApiServices/restapi.service';
import { NativeWindoRefService } from '../shared/services/native-windo-ref.service';
import { QuestionnaireTemplate } from '../classes/questionnaireDetail';
import { superAdminService } from '../shared/services/superAdminService';
import { Router, ActivatedRoute } from '@angular/router';
import { isUndefined } from "util";
import { TabsDataService } from '../shared/services/tabs-data.service';
import { DeleteSurveyDialogComponent } from "../questionnaires/questionnaires.component";
import { EditSurveyInfoComponent } from "../questionnaires/questionnaires.component";
import { CopySurveyDialogComponent } from "../questionnaires/questionnaires.component";
import { ToastyService, ToastyConfig, ToastOptions, ToastData } from 'ng2-toasty';

@Component({
  selector: 'app-form-overview',
  templateUrl: './form-overview.component.html',
  styleUrls: ['./form-overview.component.css']
})

// Unused Component
export class formOverviewComponent implements OnInit{
  nativeWindow:any;
  userTemplates:QuestionnaireTemplate[];
  qID:string;
  surveyname:string;
  questions:any;
  questionsLength:number;
  cascad:any;
  child_group:any;
  sub_form:any = [];
  surveyDetails:any;
  openDialog:any;
  createTemplate:any;
  download:any;
  constructor(public route:ActivatedRoute,public superAdminService:superAdminService, public router: Router, public dialog: MatDialog, private restApiService: RestApiService, private nativeWindoRefService: NativeWindoRefService, private toastyService: ToastyService, private toastyConfig: ToastyConfig,private tabsDataService:TabsDataService){
    this.nativeWindow = nativeWindoRefService.getNativeWindow();
    this.route.params.subscribe(params => {
      this.qID = params['id'];
    });
  }
  ngOnInit(){
    this.restApiService.getQnrWithDetailsService(this.qID).subscribe(value => {
      this.sub_form = [];
      for(var i = 0; i < value.result.length; i++){
        if(value.result[i].qID === this.qID){
          this.surveyDetails = value.result[i];
          this.surveyname = value.result[i].surveyName;
          this.questions = value.result[i].question;
          this.questionsLength = this.questions.length;
          this.cascad = JSON.stringify(value.result[i].cascadeLocation);
          this.child_group = value.result[i].child_group;
        }
        else{
          this.sub_form.push(value.result[i]);
        }
      }
      let temp:any = [];
      for(let i = 0; i < this.child_group.length; i++){
        for(let j = 0; j < this.sub_form.length; j++)
        {
          if(this.child_group[i] == this.sub_form[j].qID){
            temp.push(this.sub_form[j])
          }
        }
      }
      this.sub_form = temp;
    })
    this.getUserTemplates();
  }
  getUserTemplates() {
    // console.log('getting user templates');
    let browserStorage = localStorage.getItem('browserStorage');

    if (!isUndefined(browserStorage) && browserStorage != null) {
      // let token = JSON.parse(localStorage.getItem('browserStorage')).accessToken;
      this.restApiService.getUserTemplates().subscribe(
        result => {

          this.userTemplates = result.result;
        });
    }

  }
  editQuestionnaire(ID){
    var currentAbsoluteUrl = this.nativeWindow.location.href;
    var currentRelativeUrl = this.router.url;
    var index = currentAbsoluteUrl.indexOf(currentRelativeUrl);
    var baseUrl = currentAbsoluteUrl.substring(0, index);
    window.open(baseUrl + '/create-questionnaire/' + ID);
  }
  
  openBlankSurveyDialog(){
    let newSurveyDialogRef = this.dialog.open(BlankSurveyDialogComponent, {
      width: '800px',
      height: '54rem',
      data: {type:1,questionaire_type:1,form_type:"Sub",parentId:this.qID}
    });
    newSurveyDialogRef.afterClosed().subscribe(result => {
      if (result && result.success != false) {
        this.ngOnInit();
      }
    });
  }
  deleteqnr(qnr,qnrName,type){
    let dialogRef = this.dialog.open(DeleteSurveyDialogComponent, {
      height: '200px',
      width: '600px',
      data:{type:type,qID:qnr,surveyName:qnrName}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.tabsDataService.setSurveyTabDataTobeUpdated(true);
    });
  }
  editSurvey(qnr){
    let dialogRef = this.dialog.open(EditSurveyInfoComponent, {
      height: '300px',
      width: '600px',
      data:qnr
    });
    dialogRef.afterClosed().subscribe(result => {
      // console.log("edited");
    });
  }
  movetotop(data){
    let temp:any[] = this.child_group;
    let index = temp.indexOf(data);
    var element = temp[index];
    temp.splice(index, 1);
    temp.splice(0, 0, element);
    this.restApiService.updatechildgroupservice(this.qID,temp).subscribe(value => {
      this.ngOnInit();
    });
  }
  //To move the subform at the bottom
  movetobottom(data){
    let temp:any[] = this.child_group;
    let index = temp.indexOf(data);
    var element = temp[index];
    temp.splice(index, 1);
    temp.splice(temp.length, 0, element);
    this.restApiService.updatechildgroupservice(this.qID,temp).subscribe(value => {
      this.ngOnInit();
    });
  }
  movedownby(data,position){
    let temp:any[] = this.child_group;
    let index = temp.indexOf(data);
    var element = temp[index];
    temp.splice(index, 1);
    if(index + position > temp.length){
      temp.splice(temp.length, 0, element);
    }
    else{
      temp.splice(index+position, 0, element);
    }
    this.restApiService.updatechildgroupservice(this.qID,temp).subscribe(value => {
      // console.log(value);
    });
  }
  moveupby(data,position){
    let temp:any[] = this.child_group;
    let index = temp.indexOf(data);
    var element = temp[index];
    temp.splice(index, 1);
    if(index - position < 0){
      temp.splice(0, 0, element);
    }
    else{
      temp.splice(index - position, 0, element);
    }
    this.restApiService.updatechildgroupservice(this.qID,temp).subscribe(value => {
      // console.log(value);
    });
  }
  moveKeyPressInitial(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }
  moveKeyup(event: any) {

    if (event.target.value.charAt(event.target.value.length - 1) === " ") {
      event.target.value = event.target.value.substring(0, event.target.value.length - 1);
    }
  }
  stopPropagation(event){
    event.stopPropagation();
  }
  shouldIShowQuestion(question: any): boolean {

    //If The repeat dependence is not null then question should be shown in repeater dialog box and not here
    //Hence retuning false if repeatDependence if not null
    //Also setting is_Visible property false to mark that current question is not shown
    if (question.Parent_Repeat !== null) {
      question.is_Visible = false;
      return false;
    }


    //Checking if current question is option dependent
    //If it is then we need to check if its options criteria is satisfied to decide whether to show it or not
    if (question.Opt_Dep.length > 0) {

      //If this questions parent has not received a user response then it will straight a way not shown
      //So it checks if its parent has a user response
      if (this.questions[question.Parent_Dep - 1].user_Res[0].length > 0) {

        //Looping over all the responses user submitted for this questions parent
        //The criteria should match any one of the response to show this question
        let answers = this.questions[question.Parent_Dep - 1].user_Res[0].split(" ");
        for (let answer of answers) {

          if (!isNaN(parseInt(answer))) {
            //Looping over all the options for which to show this question
            for (let option of question.Opt_Dep) {

              //if answer matches this option then will show the question given that it also match the age range criteria
              if (parseInt(answer) === option) {

                //If there is no age range defined for this question then we can show this question
                if (parseInt((question.Age_Range.length).toString()) == parseInt('0') && this.questions[question.Parent_Dep - 1].is_Visible) {
                  question.is_Visible = true;
                  return true;
                }
                //This question has a age range defined and hence should check if it is satisfied
                else {

                  //If this question's parents is not visible then this question will also not be shown
                  if (!this.questions[question.Parent_Dep - 1].is_Visible) {
                    question.is_Visible = false;
                    return false;
                  }
                  //If this question's parent is visible then we will have to check the age range
                  else {

                    if (!this.questions[question.Parent_Age - 1].is_Visible || this.questions[question.Parent_Age - 1].user_Res.length === 0) {
                      question.is_Visible = false;
                      return false;
                    }

                    if (parseInt(this.questions[question.Parent_Age - 1].user_Res[0]) >= question.Age_Range[0] && parseInt(this.questions[question.Parent_Age - 1].user_Res[0]) <= question.Age_Range[1]) {
                      question.is_Visible = true;
                      return true;
                    } else {
                      question.is_Visible = false;
                      return false;
                    }


                  }

                }
              }
            }
          }
        }
      }

      //Otherwise the question should not be shown
      question.is_Visible = false;
      return false;
    }

    //General question will be aged checked based on same theory as above
    //Read the comments above
    if (parseInt((question.Age_Range.length).toString()) == parseInt('0')) {
      question.is_Visible = true;
      return true;
    }
    else {

      if (!this.questions[question.Parent_Age - 1].is_Visible) {
        question.is_Visible = false;
        return false;

      } else {


        if (!this.questions[question.Parent_Age - 1].is_Visible || this.questions[question.Parent_Age - 1].user_Res.length === 0) {
          question.is_Visible = false;
          return false;
        }

        if (parseInt(this.questions[question.Parent_Age - 1].user_Res[0]) >= question.Age_Range[0] && parseInt(this.questions[question.Parent_Age - 1].user_Res[0]) <= question.Age_Range[1]) {
          question.is_Visible = true;
          return true;
        } else {
          question.is_Visible = false;
          return false;
        }

      }

    }

  }
  goback(){
    var currentAbsoluteUrl = this.nativeWindow.location.href;
    var currentRelativeUrl = this.router.url;
    var index = currentAbsoluteUrl.indexOf(currentRelativeUrl);
    var baseUrl = currentAbsoluteUrl.substring(0, index);
    baseUrl = baseUrl + "/questionnaires";
    this.nativeWindow.location.href = baseUrl;
  }
  createCopy(qnr,type,form_type){
    //copyQnr=qnr;
    let dialogRef = this.dialog.open(CopySurveyDialogComponent, {
      width: '550px',
      height: '260px',
      data:{qnr:qnr,qnr_type:type,form_type:form_type,parent_Id:this.qID}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.ngOnInit();
    });
  }
  isQuestionDep(question) : boolean{

    if(question.Qn_Deps.length > 0){
      return true;
    }

    return false;

  }
}



// WEBPACK FOOTER //
// ./src/app/formoverview/form-overview.component.ts